module.exports = __webpack_public_path__ + "assets/img/kt-renewed-1.d612d425.png";